export default __webpack_public_path__ + "static/plum-ring-wax-7b6edb6b1c1628e891f67a5d5b40b2cc.png";